// ── Note ──────────────────────────────────────────────────────────────────────
//
// One page component for every note. The title, date and preview card come
// from the note's entry in src/routes.json — the same entry the prerender
// script writes into the served HTML — and the words come from the body
// registered for its path in src/notes/index.ts.
//
// Every note ends on the same two asks as the rest of the site: the free
// calculator, and the diagnostic. No newsletter box, no "subscribe" — the
// no-gate rule applies here too.

import React from "react";
import { ROUTES } from "./routes";
import { NOTE_BODIES } from "./notes";
import { NotesShell, formatDate, heading, label, wrap } from "./notes/chrome";
import type { PageProps } from "./types";

export default function Note({ brand, path }: PageProps): React.JSX.Element {
  const meta = ROUTES[path];
  const Body = NOTE_BODIES[path];

  if (!meta || !Body) {
    return (
      <NotesShell brand={brand}>
        <div style={{ ...wrap, maxWidth:720, padding:"60px 24px" }}>
          <h1 style={{ ...heading, fontSize:40 }}>This note has moved</h1>
          <p style={{ marginTop:16, color:"var(--text-muted)" }}><a href="/notes" style={{ color:brand.primary }}>See all notes</a></p>
        </div>
      </NotesShell>
    );
  }

  return (
    <NotesShell brand={brand}>
      <article style={{ ...wrap, maxWidth:720, padding:"44px 24px 60px" }}>
        <a href="/notes" style={{ ...label, color:brand.primary, textDecoration:"none" }}>← Notes</a>
        <h1 style={{ ...heading, fontSize:"clamp(34px, 6.5vw, 52px)", lineHeight:1.05, margin:"16px 0 14px" }}>{meta.ogTitle}</h1>
        <div style={{ fontSize:13, color:"var(--text-faint)", marginBottom:34 }}>{formatDate(meta.published)}</div>
        <Body brand={brand} />
      </article>

      <div style={{ position:"relative", borderTop:"1px solid var(--border-subtle)", padding:"52px 0" }}>
        <div style={{ ...wrap, maxWidth:720, display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(260px,1fr))", gap:20 }}>
          <a href="/card-fees" style={{ background:"var(--surface)", border:`1px solid ${brand.primary}`, borderRadius:10, padding:"22px", textDecoration:"none" }}>
            <div style={{ ...label, color:brand.primary, marginBottom:10 }}>Free · no sign-up</div>
            <div style={{ ...heading, fontSize:24, marginBottom:8 }}>What are card fees costing you?</div>
            <div style={{ fontSize:14, color:"var(--text-muted)", lineHeight:1.6 }}>Put your fleet into the calculator and see how much of the bill is tap count rather than sales.</div>
          </a>
          <a href="/#diagnostic" style={{ background:"var(--surface)", border:"1px solid var(--border-subtle)", borderRadius:10, padding:"22px", textDecoration:"none" }}>
            <div style={{ ...label, marginBottom:10 }}>The diagnostic</div>
            <div style={{ ...heading, fontSize:24, marginBottom:8 }}>Trace a deposit with us</div>
            <div style={{ fontSize:14, color:"var(--text-muted)", lineHeight:1.6 }}>Send one month of settlement detail, telemetry and bank statement, and we will walk a deposit back to the machines that produced it.</div>
          </a>
        </div>
      </div>
    </NotesShell>
  );
}
